import i18n from '@/i18n'
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  // const reg = /^(([^<>()\()[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
  return reg.test(email)
}
/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

// 验证身份证
export function checkIdCard(rule, value, callback) {
  if (!value) {
    return callback()
  }
  setTimeout(() => {
    const city = {11: i18n.t('utils.validate.2595932-0'), 12: i18n.t('utils.validate.2595932-1'), 13: i18n.t('utils.validate.2595932-2'), 14: i18n.t('utils.validate.2595932-3'), 15: i18n.t('utils.validate.2595932-4'), 21: i18n.t('utils.validate.2595932-5'), 22: i18n.t('utils.validate.2595932-6'), 23: '黑龙江 ', 31: i18n.t('utils.validate.2595932-8'), 32: i18n.t('utils.validate.2595932-9'), 33: i18n.t('utils.validate.2595932-10'), 34: i18n.t('utils.validate.2595932-11'), 35: i18n.t('utils.validate.2595932-12'), 36: i18n.t('utils.validate.2595932-13'), 37: i18n.t('utils.validate.2595932-14'), 41: i18n.t('utils.validate.2595932-15'), 42: '湖北 ', 43: i18n.t('utils.validate.2595932-17'), 44: i18n.t('utils.validate.2595932-18'), 45: i18n.t('utils.validate.2595932-19'), 46: i18n.t('utils.validate.2595932-20'), 50: i18n.t('utils.validate.2595932-21'), 51: i18n.t('utils.validate.2595932-22'), 52: i18n.t('utils.validate.2595932-23'), 53: i18n.t('utils.validate.2595932-24'), 54: '西藏 ', 61: i18n.t('utils.validate.2595932-26'), 62: i18n.t('utils.validate.2595932-27'), 63: i18n.t('utils.validate.2595932-28'), 64: i18n.t('utils.validate.2595932-29'), 65: i18n.t('utils.validate.2595932-30'), 71: i18n.t('utils.validate.2595932-31'), 81: i18n.t('utils.validate.2595932-32'), 82: i18n.t('utils.validate.2595932-33'), 91: '国外 '}
    let tip = ''
    let pass = true

    if (!value || !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/i.test(value)) {
      tip = i18n.t('utils.validate.2595932-35')
      pass = false
    } else if (!city[value.substr(0, 2)]) {
      tip = i18n.t('utils.validate.2595932-36')
      pass = false
    } else {
      // 18位身份证需要验证最后一位校验位
      if (value.length === 18) {
        value = value.split('')
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        const factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ]
        // 校验位
        const parity = [ '1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2' ]
        let sum = 0
        let ai = 0
        let wi = 0
        for (let i = 0; i < 17; i++) {
          ai = value[i]
          wi = factor[i]
          sum += ai * wi
        }
        if (parity[sum % 11] !== value[17]) {
          tip = i18n.t('utils.validate.2595932-37')
          pass = false
        }
      }
    }
    if (!pass) {
      callback(new Error(tip))
    } else {
      callback()
    }
  }, 500)
}

// 验证密码规则
// 规则：长度8到16位，包含字母、数字或特殊字符，其中特殊字符包括#@!~%^&*$`~()-_=+{}|;':",./<>?[]  `~()-_=+{}|;':",./<>?   #@!~%^&*$`()-_=+{}|;':",./<>?
export function validatePass(rule, value, callback) {
  // if (!/^(?=.*[a-z])(?=.*\d)(?=.*[#@!~%^&*$`()_=+{}|;':",./<>?])[a-z\d#@!~%^&*$`()_=+{}|;':",./<>?]{8,16}$/i.test(value)) {
  //   callback(new Error('密码必须为长度8-16位，且为字母、数字和非空格特殊字符的混合组合'))
  // } else {
  //   callback()
  // }
  if (value && !/^(?=.*[a-z])(?=.*\d)(?=.*[#@!~%^&*$`()_=\-+{}|;':",./<>?])[a-z\d#@!~%^&*$`()_=\-+{}|;':",./<>?]{6,16}$/i.test(value)) {
    callback(new Error(i18n.t('utils.validate.2595932-38')))
  } else {
    callback()
  }
}

// 数字验证（可为空）
// 因位数较长时，使用默认number验证会有问题
export function checkNumber(rule, value, callback) {
  setTimeout(() => {
    if (value && !/^[0-9]*$/i.test(value)) {
      callback(new Error(i18n.t('utils.validate.2595932-39')))
    } else {
      callback()
    }
  }, 300)
}

// 电话号码校验
// 支持手机号码，3-4位区号，7-8位直播号码，1-4位分机号
export function validatePhone(rule, value, callback) {
  setTimeout(() => {
    if (value && !/((^\d{11}$)|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/i.test(value)) {
      callback(new Error(i18n.t('utils.validate.2595932-40')))
    } else {
      callback()
    }
  }, 300)
}

// IPv4地址校验
export function validateIP(rule, value, callback) {
  setTimeout(() => {
    if (value && !(/^(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])$/).test(value)) {
      callback(new Error(i18n.t('utils.validate.2595932-41')))
    } else {
      callback()
    }
  }, 300)
}

// 端口号校验
export function validatePort(rule, value, callback) {
  setTimeout(() => {
    if (value < 0 || value > 65535) {
      callback(new Error(i18n.t('utils.validate.2595932-42')))
    } else {
      callback()
    }
  }, 300)
}

// 空格校验
export function validateNoSpace(rule, value, callback) {
  setTimeout(() => {
    if (value && !(/^[^\s]*$/).test(value)) {
      callback(new Error(i18n.t('utils.validate.2595932-43')))
    } else {
      callback()
    }
  }, 300)
}

// 正整数校验
export function isIntGreateZero(rule, value, callback) {
  setTimeout(() => {
    if (value) {
      if (value !== '' && value !== null && !/^\+?[1-9]\d*$/.test(value)) {
        callback(new Error(i18n.t('utils.validate.2595932-44')))
      } else {
        if (value === 0) {
          callback(new Error(i18n.t('utils.validate.2595932-44')))
        } else {
          callback()
        }
      }
    } else {
      callback()
    }

  }, 300)
}

// 字母+数字校验
export function validateNumLetter(rule, value, callback) {
  setTimeout(() => {
    if (value && !(/^[a-zA-Z0-9]*$/).test(value)) {
      callback(new Error(i18n.t('utils.validate.2595932-45')))
    } else {
      callback()
    }
  }, 300)
}
